import React, {Component} from 'react';
import {
    Platform,
    StyleSheet,
    Text,
    View,
    TouchableOpacity,
    StatusBar,
    TextInput,
    I18nManager,
    ToastAndroid,
    Image, ScrollView
} from 'react-native';
import HMTextView from "./HMTextView";
import Colors from "../tools/Colors"
import {moderateScale} from "../tools/Scaling";

import {connect} from "react-redux";

class HMListSelect extends Component {

    render() {
        const {data, onPress, style} = this.props;

        return (
            <ScrollView

                style={[{
                    //alignSelf: 'center',
                    // backgroundColor:'#ee015f'
                }, style]}
                contentContainerStyle={{
                    //flex: 1,
                    //  alignItems: 'center',
                    //justifyContent: 'center',
                }}

            >
                <View
                    style={{
                        flexDirection: 'row',
                        //   marginHorizontal: moderateScale(30),
                        // alignItems: 'center',
                        // justifyContent:'center',
                        flexWrap: 'wrap',
                        //flex: 1,

                        flexGrow: 1,
                        //   backgroundColor: "#b0ee56"
                        //
                    }}>
                    {
                        data.list.map((item, index) => {
                            let id = item.id ? item.id : item.Serial

                            return <TouchableOpacity
                                style={{
                                    //    flexDirection: 'row',
                                    marginHorizontal: moderateScale(6),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    //  height: moderateScale(34)
                                }}
                                onPress={
                                    () => {
                                        onPress(item, data.name, data.indexSelect === id)
                                    }}>
                                <View style={{
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                    //  backgroundColor: '#ffffff',
                                    borderRadius: moderateScale(24),
                                    overflow: 'hidden',
                                    borderColor: data.indexSelect === id ? Colors.colorPrimary : Colors.light,


                                    alignItems: 'center', justifyContent: 'center',
                                    borderWidth: moderateScale(1),
                                    backgroundColor: Colors.white,
                                    // borderColor:Colors.gray

                                }}>
                                    <Image
                                        source={{uri: item.Image ? item.Image : item.image}}
                                        //resizeMode="stretch"
                                        style={[{}, {


                                            width: '100%',
                                            height: '100%',
                                        }]}/>
                                </View>
                                <HMTextView
                                    //  numberOfLines={1}
                                    // type={'bold'}
                                    text={item.name ? item.name : item.Name}
                                    style={{

                                        color: data.indexSelect === id ? Colors.colorPrimary : Colors.colorDarkText,
                                        // marginEnd: moderateScale(10),
                                        fontSize: moderateScale(12),
                                        // textAlign: 'center',
                                        marginHorizontal: moderateScale(4)

                                    }}/>
                            </TouchableOpacity>

                        })
                    }
                </View>
            </ScrollView>
        );
    }
}

const styles = StyleSheet.create({

    rowContainer: {
        flexDirection: "row",
    }
});


const mapStateToProps = (state) => {

    return {
     //   data_splash: state.reducerSplashGetAllData
    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMListSelect);
